<template>
  <div class="container mx-auto px-4 py-8 min-h-screen">
    <!-- Header Section -->
    <div class="mb-8">
      <h1 class="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 break-words">
      
        <span class="text-[#157813] block sm:inline mt-2 sm:mt-0">
          {{ feature }}
        </span>
      </h1>
    </div>

    <!-- Content Section -->
    <div 
      v-if="filteredQueries.length > 0" 
      class="w-full"
    >
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        <div 
          v-for="query in filteredQueries" 
          :key="query.id"
          class="w-full"
        >
          <QueryCard
            :query="query"
            @click="showQueryDetails(query.id)"
            class="h-full transition-transform duration-300 hover:scale-105"
          />
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div 
      v-else 
      class="flex flex-col items-center justify-center space-y-4 min-h-[50vh]"
    >
      <p class="text-gray-500 text-lg md:text-xl font-medium text-center uppercase">
        No queries found for this feature
      </p>
      <button 
        @click="$router.push('/')" 
        class="px-6 py-2 bg-[#157813] text-white rounded-lg hover:bg-[#1a8f17] transition-colors duration-300"
      >
        Back to Home
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import QueryCard from "@/components/QueryCard.vue";
import { Query, transformQueries } from "@/models/Query";
import rawQueries from "@/queries.json";
import { computed, defineComponent, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: { QueryCard },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const queries = ref<Query[]>(transformQueries(rawQueries));
    const feature = route.query.feature as string;

    const filteredQueries = computed(() =>
      queries.value.filter((query) =>
        query.features.some(
          (tag) => tag.toLowerCase() === feature?.toLowerCase()
        )
      )
    );

    const showQueryDetails = (queryId: string) => {
      router.push(`/query/${queryId}`);
    };

    return { feature, filteredQueries, showQueryDetails };
  },
});
</script>